import template from './edit.html';
import controller from './edit.controller';

const editProductComponent = {
  bindings: {
    mode: '@', // 'create', 'edit' (needs a product object)
    product: '=?',
    onCancel: '&'
  },
  template,
  controller
};

export default editProductComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/menu/catalog/edit/edit.component.js
 **/